<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
const [name] = createNamespace('RewardNoResettleStandardForm')

export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>,
      default: () => ({})
    }
  },
  setup(props) {
    return () => (
      <div class='ant-row-form-item'>
        拆迁奖励及搬迁补助按住房面积（不含生产经营性用房）补偿款的
        <b>{props.data?.chaiQianBuYuAnZhi ?? '-'} %</b>
        计算。
      </div>
    )
  }
})
</script>
